module.exports = __webpack_public_path__ + "static/img/43.965acc23.png";